import { configureStore } from '@reduxjs/toolkit'
import sessionReducer from './sessionSlice'
import canvasReducer from './canvasSlice'

const store = configureStore({
  reducer: {
    session: sessionReducer,
    canvas: canvasReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
